export const GET_VIEW_TEA_SOLD = "GET_VIEW_TEA_SOLD";
export const GET_VIEW_TEA_SOLD_SUCCESS = "GET_VIEW_TEA_SOLD_SUCCESS";
export const GET_VIEW_TEA_SOLD_FAIL = "GET_VIEW_TEA_SOLD_FAIL";
export const GET_MY_VIEW_TEA_VIEW_LOADING = "GET_MY_VIEW_TEA_VIEW_LOADING";

export const GET_VIEW_TEA_SOLD_LOT = "GET_VIEW_TEA_SOLD_LOT";
export const GET_VIEW_TEA_SOLD_LOT_SUCCES = "GET_VIEW_TEA_SOLD_LOT_SUCCES";
export const GET_VIEW_TEA_SOLD_LOT_FAIL = "GET_VIEW_TEA_SOLD_LOT_FAIL";

export const GET_VIEW_TEA_SOLD_LOT_MARKET = "GET_VIEW_TEA_SOLD_LOT_MARKET";
export const GET_VIEW_TEA_SOLD_LOT_MARKET_SUCCES =
  "GET_VIEW_TEA_SOLD_LOT_MARKET_SUCCES";
export const GET_VIEW_TEA_SOLD_LOT_MARKET_FAIL =
  "GET_VIEW_TEA_SOLD_LOT_MARKET_FAIL";
export const GET_MY_VIEW_TEA_LOT_VIEW_LOADING =
  "GET_MY_VIEW_TEA_LOT_VIEW_LOADING";

export const GET_VIEW_TEA_AUCTIONEER = "GET_VIEW_TEA_AUCTIONEER";
export const GET_VIEW_TEA_AUCTIONEER_SUCCES = "GET_VIEW_TEA_AUCTIONEER_SUCCES";
export const GET_VIEW_TEA_AUCTIONEER_FAIL = "GET_VIEW_TEA_AUCTIONEER_FAIL";
export const GET_MY_AUCTIONEER_VIEW_LOADING = "GET_MY_AUCTIONEER_VIEW_LOADING";

export const GET_VIEW_MARKET_SUMMARY = "GET_VIEW_MARKET_SUMMARY";
export const GET_VIEW_MARKET_SUMMARY_SUCCES = "GET_VIEW_MARKET_SUMMARY_SUCCES";
export const GET_VIEW_MARKET_SUMMARY_FAIL = "GET_VIEW_MARKET_SUMMARY_FAIL";
export const GET_MY_VIEW_MARKET_VIEW_LOADING =
  "GET_MY_VIEW_MARKET_VIEW_LOADING";
export const GET_MY_VIEW_TEA_SOLD_VIEW_LOADING =
  "GET_MY_VIEW_TEA_SOLD_VIEW_LOADING";

export const GET_MY_PLANNER_ENG = "GET_MY_PLANNER_ENG";
export const GET_MY_PLANNER_ENG_SUCCES = "GET_MY_PLANNER_ENG_SUCCES";
export const GET_MY_PLANNER_ENG_FAIL = "GET_MY_PLANNER_ENG_FAIL";
export const GET_MY_PLANNER_VIEW_LOADING = "GET_MY_PLANNER_VIEW_LOADING";

export const GET_MY_CATALOG_VIEW = "GET_MY_CATALOG_VIEW";
export const GET_MY_CATALOG_VIEW_SUCCES = "GET_MY_CATALOG_VIEW_SUCCES";
export const GET_MY_CATALOG_VIEW_FAIL = "GET_MY_CATALOG_VIEW_FAIL";
export const GET_MY_CATALOG_VIEW_LOADING = "GET_MY_CATALOG_VIEW_LOADING";

export const GET_MY_CATALOG_ADD = "GET_MY_CATALOG_ADD";
export const GET_MY_CATALOG_ADD_SUCCES = "GET_MY_CATALOG_ADD_SUCCES";
export const GET_MY_CATALOG_ADD_FAIL = "GET_MY_CATALOG_ADD_FAIL";

export const GET_MY_CATALOG_REMOVE = "GET_MY_CATALOG_REMOVE";
export const GET_MY_CATALOG_REMOVE_SUCCES = "GET_MY_CATALOG_REMOVE_SUCCES";
export const GET_MY_CATALOG_REMOVE_FAIL = "GET_MY_CATALOG_REMOVE_FAIL";

export const GET_MY_CATALOG_STUTAS = "GET_MY_CATALOG_STUTAS";

export const CHANGE_RESERVE_PRICE = "CHANGE_RESERVE_PRICE";
export const CHANGE_RESERVE_PRICE_SUCCES = "CHANGE_RESERVE_PRICE_SUCCES";
export const CHANGE_RESERVE_PRICE_FAIL = "CHANGE_RESERVE_PRICE_FAIL";

export const ADD_MY_CATALOG_STUTAS = "ADD_MY_CATALOG_STUTAS";
export const REMOVE_MY_CATALOG_STUTAS = "REMOVE_MY_CATALOG_STUTAS";

export const CHANGE_PRICE_STUTAS = "CHANGE_PRICE_STUTAS";

export const GET_MARKET_DEPTH = "GET_MARKET_DEPTH";
export const GET_MARKET_DEPTH_SUCCES = "GET_MARKET_DEPTH_SUCCES";
export const GET_MARKET_DEPTH_FAIL = "GET_MARKET_DEPTH_FAIL";
export const GET_MY_MARKET_DEPTH_VIEW_LOADING =
  "GET_MY_MARKET_DEPTH_VIEW_LOADING";

export const COLUMN_CONFIG_TABLE = "COLUMN_CONFIG_TABLE";
export const COLUMN_CONFIG_TABLE_SUCCES = "COLUMN_CONFIG_TABLE_SUCCES";
export const COLUMN_CONFIG_TABLE_FAIL = "COLUMN_CONFIG_TABLE_FAIL";

export const USERWISE_CONFIG_TABLE = "USERWISE_CONFIG_TABLE";
export const USERWISE_CONFIG_TABLE_SUCCES = "USERWISE_CONFIG_TABLE_SUCCES";
export const USERWISE_CONFIG_TABLE_FAIL = "USERWISE_CONFIG_TABLE_FAIL";

export const DEFULT_CONFIG_TABLE = "DEFULT_CONFIG_TABLE";
export const DEFULT_CONFIG_TABLE_SUCCES = "DEFULT_CONFIG_TABLE_SUCCES";
export const DEFULT_CONFIG_TABLE_FAIL = "DEFULT_CONFIG_TABLE_FAIL";

export const USERWISE_CATALOG_STUTAS = "USERWISE_CATALOG_STUTAS";

export const DEFUALT_CATALOG_STUTAS = "DEFUALT_CATALOG_STUTAS";

export const GROUP_CODE_TABLE = "GROUP_CODE_TABLE";
export const GROUP_CODE_TABLE_SUCCES = "GROUP_CODE_TABLE_SUCCES";
export const GROUP_CODE_TABLE_FAIL = "GROUP_CODE_TABLE_FAIL";

export const ADD_VALUATION_ACTION = "ADD_VALUATION_ACTION";
export const ADD_VALUATION_ACTION_SUCCES = "ADD_VALUATION_ACTION_SUCCES";
export const ADD_VALUATION_ACTION_FAIL = "ADD_VALUATION_ACTION_FAIL";

export const VALUE_STUTAS = "VALUE_STUTAS";

export const IS_RP_BUTTON_CLICKED_TRUE = "IS_RP_BUTTON_CLICKED_TRUE";
export const IS_RP_BUTTON_CLICKED_FALSE = "IS_RP_BUTTON_CLICKED_FALSE"
